import { ModalsProvider } from '@speeki/global-ui-components';
import { StorageManager } from '@speeki/storage-manager';

import {
    Auth_User_Relationship,
    Country_Code,
} from '@graphql/generated/graphql';

import { useUserCompany } from '@utils/hooks/useUserCompany';

import { useLoginGuest } from '@services/AuthService/useLoginGuest';

import { useReactiveVar } from '@apollo/client';
import {
    currentLanguageVar,
    guestLoginFormDataVar,
    sessionProcessingVar,
} from '@boot/reactiveVariables';
import { GuestLoginFormValues } from '@domains/auth/organisms/GuestLoginForm/GuestLoginForm';

export const useGuestLogin = () => {
    const companyUuid = StorageManager.getValue('tenantUuid');
    const sessionProcessing = useReactiveVar(sessionProcessingVar);

    const { data: userData } = useUserCompany();

    const tenantId = companyUuid ?? userData?.user.tenant?.uuid ?? '';

    const { handleGuestLogin } = useLoginGuest();

    const openGuestModal = (data: GuestLoginFormValues) => {
        guestLoginFormDataVar(data);
        ModalsProvider.open('TermsAndConditionsInfoModal');
    };

    const loginGuest = async (data: GuestLoginFormValues) => {
        await handleGuestLogin(
            {
                input: {
                    country: data.country.value as Country_Code,
                    language: currentLanguageVar(),
                    relationship: data.relationship
                        .value as Auth_User_Relationship,
                    tenantUuid: tenantId,
                },
            },
            {
                onSuccess: () => {
                    ModalsProvider.close('TermsAndConditionsInfoModal');
                    guestLoginFormDataVar(null);
                },
            },
        );
    };

    return {
        loginGuest,
        openGuestModal,
        sessionProcessing,
    };
};
